module.exports = __webpack_public_path__ + "static/brems-verksted-52fd40c1af6732377411e73b9cd54290.mp4";